export const menus = [
  {
    name: "Dashboard",
    route: [
      {
        name: "Dashboard",
        route: "/dashboard",
        icon: "bi bi-speedometer2",
      },
      {
        name: "Executive Dashboard",
        route: "/executive_dashboard",
        icon: "bi bi-speedometer2",
      },
    ],
    icon: "bi bi-sliders",
  },
  {
    name: "Task Board",
    route: "/taskboard",
    isParent: true,
    icon: "bi bi-person-vcard",
  },
  {
    name: "Service Request Logs",
    route: "/request",
    isParent: true,
    icon: "bi bi-person-vcard",
  },
  {
    name: "Service Request",
    route: "/service",
    isParent: true,
    icon: "bi bi-person-lines-fill",
  },
  {
    name: "Employee Self Service",
    icon: "bi bi-sliders",
    route: [
      {
        name: "Time Management",
        route: "/tmanagement",
        icon: "bi bi-hourglass",
      },
      {
        name: "Leave Management",
        route: "/lmanagement",
        icon: "bi bi-bag",
      },
      {
        name: "Overtime",
        route: "/overtime",
        icon: "bi bi-clock",
      },
      {
        name: "ESS Trainings",
        route: "/training",
        icon: "bi bi-bar-chart-steps",
      },
      {
        name: "Payslip",
        route: "/payslip",
        icon: "bi bi-person-vcard",
      },
      {
        name: "OB Request",
        route: "/ob_requests",
        icon: "bi bi-files",
      },
    ],
  },

  {
    name: "My Performance",
    route: "/my-performance",
    isParent: true,
    icon: "bi bi-person-lines-fill",
  },
  {
    name: "Performance",
    icon: "bi bi-journal-bookmark",
    route: [
      {
        name: "IPCR",
        route: "/ipcr",
        icon: "bi bi-journal-richtext",
      },
      {
        name: "OPCR",
        route: "/opcr",
        icon: "bi bi-journals",
      },
      {
        name: "DPCR",
        route: "/dpcr",
        icon: "bi bi-journal-text",
      },
      {
        name: "SPCR",
        route: "/spcr",
        icon: "bi bi-journal-text",
      },
    ],
  },
  {
    name: "Merit Reward and Recognition",
    icon: "bi bi-journal-text",
    route: [
      {
        name: "Special Award",
        route: "/specialaward",
        icon: "bi bi-star",
      },
      {
        name: "Commendation",
        route: "/commendation",
        icon: "bi bi-hand-thumbs-up",
      },
      {
        name: "Recognition",
        route: "/nomination",
        icon: "bi bi-people",
      },
      {
        name: "Accomplishments",
        route: "/accomplishments",
        icon: "bi bi-journal-text",
      },
    ],
  },
  {
    name: "Human Resource",
    icon: "bi bi-people",
    route: [
      {
        name: "Employee Records",
        route: "/employee",
        icon: "bi bi-people",
      },
      {
        name: "Timesheet",
        route: "/timesheet",
        icon: "bi bi-table",
      },
      {
        name: "Reports",
        route: "/report_list",
        icon: "bi bi-graph-up",
      },
      {
        name: "Leaves",
        route: "/leaves",
        icon: "bi bi-journal-text",
      },
      {
        name: "Overtimes",
        route: "/overtimes",
        icon: "bi bi-clock",
      },
      {
        name: "Performances",
        route: "/performance",
        icon: "bi bi-journal-check",
      },
      // {
      //   name: "HR Trainings",
      //   route: "/hr/trainings",
      //   icon: "bi bi-bar-chart-steps",
      // },
      {
        name: "Notices",
        route: "/notices",
        icon: "bi bi-person-exclamation",
      },
      {
        name: "Holidays",
        route: "/holidays",
        icon: "bi bi-calendar",
      },
      {
        name: "Library",
        route: "/library",
        icon: "bi bi-book",
      },
      {
        name: "Work Suspension",
        route: "/suspension",
        icon: "bi bi-person-workspace",
      },
      {
        name: "HRMS Application for Leave",
        route: "/hrms_for_leave",
        icon: "bi bi-person-workspace",
      },
      {
        name: "HRDD for Approval",
        route: "/hrdd_for_approval",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Airport Augmentation",
        route: "/airport_assign",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Schedule Report",
        route: "/schedule_report",
        icon: "bi bi-person",
      },
      {
        name: "OB for Approval",
        route: "/ob_requests_approval",
        icon: "bi bi-check2-square",
      },
      {
        name: "Leave Credits",
        route: "/leave_credits",
        icon: "bi bi-person-exclamation",
      },
    ],
  },
  {
    name: "Recruitment",
    icon: "bi bi-journal-check",
    route: [
      {
        name: "Position Titles",
        route: "/position_titles",
        icon: "bi bi-diagram-3",
      },
      {
        name: "Job Postings",
        route: "/job_postings",
        icon: "bi bi-pin-angle",
      },
      {
        name: "Job Applicants",
        route: "/job_applicants",
        icon: "bi bi-window-stack",
      },
    ],
  },
  {
    name: "Compensation and Benefits",
    icon: "bi bi-safe",
    route: [
      {
        name: "Generate Payroll",
        route: "/payroll",
        icon: "bi bi-wallet2",
      },
      // {
      //   name: "Generate Payroll",
      //   route: "/generate_payroll",
      //   icon: "bi bi-credit-card-2-front",
      // },
      {
        name: "Payroll List",
        route: "/payroll_list",
        icon: "bi bi-journal-bookmark",
      },
      {
        name: "Annual Taxes",
        route: "/annual_taxes",
        icon: "bi bi-graph-up",
      },
      {
        name: "Contributions",
        route: "/contributions",
        icon: "bi bi-shield-check",
      },
      {
        name: "Disbursements",
        route: "/disbursement",
        icon: "bi bi-shield-check",
      },
      {
        name: "Bank Accounts",
        route: "/bank_account",
        icon: "bi bi-bank2",
      },
      {
        name: "Employee Earnings",
        route: "/employees",
        icon: "bi bi-wallet-fill",
      },
      {
        name: "OB Management",
        route: "/ob_management",
        icon: "bi bi-kanban",
      },
      {
        name: "Payslip CEBS",
        route: "/payslip_admin",
        icon: "bi bi-person-lines-fill",
      },
      // {
      //   name: "Test Payroll",
      //   route: "/new_payroll",
      //   icon: "bi bi-wallet2",
      // },
      {
        name: "Alphalist",
        route: "/employee_records",
        icon: "bi bi-people-fill",
      },
    ],
  },
  {
    name: "System Administration",
    icon: "bi bi-gear",
    route: [
      {
        name: "Users",
        route: "/users",
        icon: "bi bi-people",
      },
      {
        name: "Roles and Permissions",
        route: "/roles",
        icon: "bi bi-window-stack",
      },
      {
        name: "Workflow Builder",
        route: "/workflows",
        icon: "bi bi-filetype-json",
      },
      {
        name: "Notice Templates",
        route: "/notice_templates",
        icon: "bi bi-pencil-square",
      },
      // {
      //   name: "Portal Settings",
      //   route: "/admin/portal-settings",
      //   icon: "bi bi-wrench-adjustable",
      // },
      // {
      //   name: "AD Health Check",
      //   route: "/ad-health",
      //   icon: "bi bi-people",
      // },
      {
        name: "Biometric",
        route: "/biometrics",
        icon: "bi bi-fingerprint",
      },
      {
        name: "Biometric Logs",
        route: "/biometric_logs",
        icon: "bi bi-fingerprint",
      },
      // {
      //   name: "Biometric Face Capture",
      //   route: "/biometric_face",
      //   icon: "bi bi-fingerprint",
      // },
      {
        name: "Audit Logs",
        route: "/audit_logs",
        icon: "bi bi-file-text",
      },
      // {
      //   name: "Batch Jobs",
      //   route: "/batch_jobs",
      //   icon: "bi bi-rocket",
      // },
      {
        name: "Manual Timesheets",
        route: "/manual_timesheets",
        icon: "bi bi-people",
      },
      {
        name: "DTR Attachment",
        route: "/manual_dtr",
        icon: "bi bi-people",
      },
      {
        name: "Access PIN",
        route: "/access_pin",
        icon: "bi bi-people",
      },
    ],
  },
  {
    name: "Organizational Structure",
    icon: "bi bi-globe",
    route: [
      {
        name: "OCOM",
        route: "/regions",
        icon: "bi bi-graph-down",
      },
      {
        name: "Location",
        route: "/offices",
        icon: "bi bi-building",
      },
      {
        name: "Region",
        route: "/divisions",
        icon: "bi bi-sign-intersection-side",
      },
      {
        name: "Subport/ IPEE/ Main RIOU",
        route: "/sections",
        icon: "bi bi-sign-stop-lights",
      },
      {
        name: "Division",
        route: "/units",
        icon: "bi bi-buildings",
      },
      {
        name: "Section/ Unit/ Other Offices",
        route: "/clusters",
        icon: "bi bi-diagram-3",
      },
    ],
  },
  {
    name: "Learning Management and Development",
    icon: "bi bi-sliders",
    route: [
      {
        name: "LMD Trainings",
        route: "/learning/training",
        icon: "bi bi-person-check",
      },
      {
        name: "Training Report",
        route: "/learning/training_report",
        icon: "bi bi-graph-up",
      },
      {
        name: "Training Schedule",
        route: "/learning/training_schedule",
        icon: "bi bi-journal-bookmark",
      },
    ],
  },
  {
    name: "Reference Tables",
    icon: "bi bi-table",
    route: [
      {
        name: "Employment Type",
        route: "/employment",
        icon: "bi bi-card-list",
      },
      {
        name: "Adjustment",
        route: "/other_deductions",
        icon: "bi bi-file-earmark-plus",
      },
      {
        name: "Payroll Type",
        route: "/payroll_type",
        icon: "bi bi-list-check",
      },
      {
        name: "Incentives",
        route: "/incentive",
        icon: "bi bi-file-earmark-plus",
      },
      {
        name: "Salary Grades",
        route: "/salary_grade",
        icon: "bi bi-diagram-3",
      },
      {
        name: "Schedule Templates",
        route: "/schedule",
        icon: "bi bi-journal-bookmark",
      },

      {
        name: "Leave Types",
        route: "/leavetype",
        icon: "bi bi-card-checklist",
      },

      {
        name: "Allowance Types",
        route: "/allowance_type",
        icon: "bi bi-wallet",
      },
      {
        name: "Contribution Types",
        route: "/contribution_type",
        icon: "bi bi-card-heading",
      },
      {
        name: "Service Request Types",
        route: "/service_request",
        icon: "bi bi-list-columns",
      },
      {
        name: "Tax Table",
        route: "/tax",
        icon: "bi bi-table",
      },
      {
        name: "Government Unit Class",
        route: "/government_unit",
        icon: "bi bi-buildings",
      },
      {
        name: "Group Schedule",
        route: "/group_schedule",
        icon: "bi bi-person-plus",
      },
      {
        name: "Non Plantilla Items",
        route: "/non_plantilla",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Nature of Functions(Designations)",
        route: "/nature_functions",
        icon: "bi bi-person-workspace",
      },
      {
        name: "AP Rate",
        route: "/pay_code",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Payroll Classifications",
        route: "/payroll_combination",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Accounts Title",
        route: "/accounts_title",
        icon: "bi bi-person-workspace",
      },
      {
        name: "Payroll Layouts",
        route: "/payroll_layouts",
        icon: "bi bi-layout-wtf",
      },
      {
        name: "Department Head",
        route: "/department_head",
        icon: "bi bi-wallet-fill",
      },
      // {
      //   name: "Payroll Type Test",
      //   route: "/payroll_type_assign",
      //   icon: "bi bi-list-check",
      // },
      // {
      //   name: "Payroll Setups",
      //   route: "/payroll_setups",
      //   icon: "bi bi-sliders",
      // },
      //   {
      //   name: "Item Options",
      //   route: "/item_options",
      //   icon: "bi bi-sliders",
      // },
    ],
  },
  {
    name: "Committee Structures",
    icon: "bi bi-table",
    route: [
      {
        name: "Committee",
        route: "/committee",
        icon: "bi bi-card-list",
      },
      {
        name: "Designation",
        route: "/committeee_category",
        icon: "bi bi-card-list",
      },
    ],
  },
  {
    name: "Medical and Dental Section",
    icon: "bi bi-hospital",
    route: [
      {
        name: "Medical Record",
        route: "/medical_record",
        icon: "bi bi-hospital",
      },
      {
        name: "Consultation",
        route: "/consultation",
        icon: "bi bi-clipboard2-pulse",
      },
      {
        name: "Dental Consultation",
        route: "/dental_consultation",
        icon: "bi bi-clipboard2-pulse",
      },
    ],
  },
  {
    name: "My Profile",
    route: "/profile",
    isParent: true,
    icon: "bi bi-person",
  },
  {
    name: "My Settings",
    route: "/settings",
    isParent: true,
    icon: "bi bi-gear-wide-connected",
  },
  {
    name: "Logout",
    // route: "/schema",
    isParent: true,
    icon: "bi bi-box-arrow-right",
  },
];
